import { ComponentChildren, h } from "preact";
import "./expandablecolumnsview.scss";

export function ExpandableColumnsContainer(props: {
    class?: string,
    children: ComponentChildren,
}) {
    return (
        <div class={"component-container row expandablecolumnsview" + (!!props.class ? (" " + props.class) : "")}>
            {
                props.children
            }
        </div>
    );
}

export function ExpandableColumn(props: {
    class?: string,
    hidden?: boolean,
    children?: ComponentChildren,
}) {
    return (
        <div class={"column" + (!!props.class ? (" " + props.class) : "") + (!!props.hidden ? " hidden" : "")}>
            {
                props.children
            }
        </div>
    );
}
